import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc752df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "single-SKU-card-header card-header flex-max-sm-column max-sm-align-items-start align-items-center" }
const _hoisted_2 = { class: "card-title m-0 flex-1" }
const _hoisted_3 = { class: "py-4 mx-2" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-inline-block align-middle fw-bolder lin-height-small" }
const _hoisted_6 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_7 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_8 = { class: "me-4" }
const _hoisted_9 = { class: "fs-6 fw-bold me-4" }
const _hoisted_10 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_13 = { class: "card-body pb-4" }
const _hoisted_14 = { class: "row border-b mt-4 pb-4" }
const _hoisted_15 = { class: "col-md-6 col-lg-3 form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = { class: "col-md-6 col-lg-3 form-group mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_19 = { class: "col-md-6 col-lg-3 form-group mb-7" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_21 = { class: "w-100 d-flex el-input el-input-group--append el-input--suffix" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " € ", -1))
const _hoisted_23 = { class: "col-md-6 col-lg-3 form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "col-md-12 col-lg-3 form-group mb-7" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_27 = { class: "col-md-12 col-lg-9 form-group mb-7" }
const _hoisted_28 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_29 = { class: "row mt-4" }
const _hoisted_30 = { class: "col-md-6 col-lg-3 form-group mb-7" }
const _hoisted_31 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_32 = { class: "col-md-6 col-lg-3 form-group mb-7" }
const _hoisted_33 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_34 = { class: "col-md-12 col-lg-6 form-group mb-7" }
const _hoisted_35 = { class: "fs-6 fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_info = _resolveComponent("product-info")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["single-SKU-card card mb-6", {
        'has-exception': _ctx.thisItem.item_exception == 10,
      }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.thisItem.position), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_product_info, {
              class: "w-40px d-inline-block align-middle mx-2 product-info-small",
              gallery: _ctx.thisItem.sku_info.gallery
            }, null, 8, ["gallery"]),
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.thisItem.sku_info.sku) + " ", 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t("dsSkuManagement.sku")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("dsSkuManagement.category")) + " : ", 1),
            _createVNode(_component_el_select, {
              modelValue: _ctx.thisItem.sku_info.attribute_set_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.thisItem.sku_info.attribute_set_id) = $event)),
              placeholder: 
                _ctx.t('common.plsSelect') + _ctx.t('dsSkuManagement.category')
              
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thisOptions.productTemplate, (productTemplateitem) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: productTemplateitem.value,
                    label: _ctx.t(`dsSkuManagement.${productTemplateitem.label}`),
                    value: productTemplateitem.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn px-3", {
              'btn-text-danger': _ctx.thisItem.item_exception == 10,
              'btn-text-primary': _ctx.thisItem.item_exception != 10,
            }]),
            "data-bs-toggle": "modal",
            "data-bs-target": "#modal_report_product_exception",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reportButtonClick && _ctx.reportButtonClick(...args)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["svg-icon svg-icon-2 svg-icon-primary", {
                'svg-icon-danger': _ctx.thisItem.item_exception == 10,
                'svg-icon-primary': _ctx.thisItem.item_exception != 10,
              }])
            }, [
              (_ctx.thisItem.item_exception != 10)
                ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                    key: 0,
                    src: "media/icons/duotune/general/gen005.svg"
                  }))
                : (_openBlock(), _createBlock(_component_inline_svg_icon, {
                    key: 1,
                    src: "media/icons/duotune/general/gen044.svg"
                  }))
            ], 2),
            _createVNode(_component_window_resize, null, {
              lg: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("dsSkuManagement.reportProductException")), 1)
              ]),
              _: 1
            })
          ], 2),
          (
              _ctx.thisItem.sku_info.brand_id != '' ||
              _ctx.thisItem.sku_info.brand_article_no != '' ||
              _ctx.thisItem.sku_info.gtin != ''
            )
            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-text-primary px-3",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal_quick_fill_tool",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchButtonClick && _ctx.searchButtonClick(...args)))
              }, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil024.svg" })
                ]),
                _createVNode(_component_window_resize, null, {
                  lg: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("dsSkuManagement.SearchProducts")), 1)
                  ]),
                  _: 1
                })
              ])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-text-primary px-3",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.notEnoughTips()))
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil024.svg" })
                  ]),
                  _createVNode(_component_window_resize, null, {
                    lg: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("dsSkuManagement.SearchProducts")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_form, {
          onSubmit: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"])),
          model: _ctx.validModel,
          ref: "formRef",
          rules: (_ctx.rules as any)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("dsSkuManagement.brand")), 1),
                _createVNode(_component_el_form_item, { prop: "brand_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      ref: "selectBrand",
                      teleported: false,
                      modelValue: _ctx.thisItem.sku_info.brand_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.thisItem.sku_info.brand_id) = $event)),
                      clearable: "",
                      filterable: "",
                      "remote-show-suffix": "",
                      remote: "",
                      "remote-method": _ctx.searchBrandSourceItems,
                      loading: _ctx.thisOptions.brandLoading,
                      placeholder: 
                    _ctx.t('common.plsSelect') + _ctx.t('dsSkuManagement.brand')
                  ,
                      onFocus: _ctx.cancelReadonly,
                      "onHook:mounted": _ctx.cancelReadonly,
                      onVisibleChange: _ctx.cancelReadonly,
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.autofillBrandName($event)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thisOptions.brand, (brandOptionItem) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: brandOptionItem.value,
                            label: brandOptionItem.label,
                            value: brandOptionItem.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "remote-method", "loading", "placeholder", "onFocus", "onHook:mounted", "onVisibleChange"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("dsSkuManagement.brandArticleNo")), 1),
                _createVNode(_component_el_form_item, { prop: "brand_article_no" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      modelValue: _ctx.thisItem.sku_info.brand_article_no,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.thisItem.sku_info.brand_article_no) = $event)),
                      clearable: "",
                      placeholder: 
                    _ctx.t('common.plsEnter') + _ctx.t('dsSkuManagement.brandArticleNo')
                  
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("dsSkuManagement.price")), 1),
                _createVNode(_component_el_form_item, { prop: "price" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_el_input_number, {
                        class: "text-end flex-1",
                        modelValue: _ctx.thisItem.sku_info.price.original_price,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.thisItem.sku_info.price.original_price) = $event)),
                        precision: 2,
                        step: 0.01,
                        min: 0.0,
                        controls: false
                      }, null, 8, ["modelValue", "step", "min"]),
                      _hoisted_22
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("dsSkuManagement.size")), 1),
                _createVNode(_component_el_form_item, { prop: "size_name" }, {
                  default: _withCtx(() => [
                    (!_ctx.isNoSizeSku(_ctx.thisItem))
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          class: "w-100",
                          ref: "selectSize",
                          teleported: false,
                          modelValue: _ctx.thisItem.sku_info.size,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.thisItem.sku_info.size) = $event)),
                          clearable: "",
                          filterable: "",
                          "remote-show-suffix": "",
                          remote: "",
                          "remote-method": 
                    (query) => {
                      _ctx.searchSizeSourceItems(
                        query,
                        _ctx.thisItem.sku_info.attribute_set_id
                      );
                    }
                  ,
                          loading: _ctx.thisOptions.sizeLoading,
                          placeholder: 
                    _ctx.t('common.plsSelect') + _ctx.t('dsSkuManagement.size')
                  ,
                          onFocus: _ctx.cancelReadonly,
                          "onHook:mounted": _ctx.cancelReadonly,
                          onVisibleChange: _ctx.cancelReadonly,
                          onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sizeSelectInput($event))),
                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sizeSelectChange($event))),
                          onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sizeSelectBlur()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thisOptions.size, (sizeOptionsItem) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: sizeOptionsItem.value,
                                label: sizeOptionsItem.label,
                                value: sizeOptionsItem.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "remote-method", "loading", "placeholder", "onFocus", "onHook:mounted", "onVisibleChange"]))
                      : (_openBlock(), _createBlock(_component_el_popover, {
                          key: 1,
                          placement: "top",
                          width: "auto",
                          trigger: "hover"
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              placeholder: _ctx.t('dsSkuManagement.oneSizeFitsAll'),
                              type: "text",
                              disabled: ""
                            }, null, 8, ["placeholder"])
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("dsSkuManagement.unableToEditSize")) + " ", 1)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("dsSkuManagement.hsCode")), 1),
                _createVNode(_component_el_form_item, { prop: "hs_code" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      modelValue: _ctx.thisItem.sku_info.hs_code.DE,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.thisItem.sku_info.hs_code.DE) = $event)),
                      clearable: "",
                      placeholder: 
                    _ctx.t('common.plsEnter') + _ctx.t('dsSkuManagement.hsCode')
                  
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("dsSkuManagement.name")), 1),
                _createVNode(_component_el_form_item, { prop: "name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      modelValue: _ctx.thisItem.sku_info.name,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.thisItem.sku_info.name) = $event)),
                      clearable: "",
                      placeholder: 
                    _ctx.t('common.plsEnter') + _ctx.t('dsSkuManagement.name')
                  ,
                      onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.autofillNameEn()))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("dsSkuManagement.ean")), 1),
                _createVNode(_component_el_form_item, { prop: "gtin" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      modelValue: _ctx.thisItem.sku_info.gtin,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.thisItem.sku_info.gtin) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('common.plsEnter') + _ctx.t('dsSkuManagement.ean')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("dsSkuManagement.countryOfOrigin")), 1),
                _createVNode(_component_el_form_item, { prop: "country_of_origin" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.thisItem.sku_info.country_of_origin,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.thisItem.sku_info.country_of_origin) = $event)),
                      filterable: "",
                      clearable: "",
                      placeholder: 
                    _ctx.t('common.plsSelect') + _ctx.t('dsSkuManagement.countryOfOrigin')
                  ,
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thisOptions.originCountry, (originCountryitem) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: originCountryitem.value,
                            label: 
                      originCountryitem.value +
                      '(' +
                      originCountryitem.label +
                      ')'
                    ,
                            value: originCountryitem.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("dsSkuManagement.material")), 1),
                _createVNode(_component_el_form_item, { prop: "material" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      modelValue: _ctx.thisItem.sku_info.material,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.thisItem.sku_info.material) = $event)),
                      clearable: "",
                      placeholder: 
                    _ctx.t('common.plsEnter') + _ctx.t('dsSkuManagement.material')
                  
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ], 2)
  ]))
}